import { Center } from '@mantine/core';
import { type FC } from 'react';
import { rdHides } from '../../rd/embedded'; // RD:
import classes from './PageSpinner.module.css';

const PageSpinner: FC = () => (
    <Center
        data-testid="page-spinner"
        pos="absolute"
        left={0}
        top={0}
        right={0}
        bottom={0}
    >
        <div
            className={rdHides('brandLoader') ? classes.shimmerRd : classes.shimmer} // RD:
        />
    </Center>
);

export default PageSpinner;
